import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ItemCreationTab = ({ BASE_URL, COMPANY_CODE }) => {
  const [itemRequests, setItemRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchItemRequests = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${BASE_URL}/api/CpaysCount/${COMPANY_CODE}/ITEMREQUESTLIST/REQUESTED/-`
        );
        if (response.ok) {
          const data = await response.json();
          setItemRequests(data);
        }
      } catch (error) {
        console.error("Error fetching item requests:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchItemRequests();
  }, []);

  const handleCreateItem = (item) => {
    navigate("/itemCreation", {
      state: {
        requestData: item,
        fromRequest: true,
      },
    });
    console.log("Request Data:", item);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden p-4">
      {/* <div className="flex justify-between items-center mb-4">
        <h2 className="text-sm font-semibold text-cyan-700">
          Pending Item Requests
        </h2>
        <div className="text-[10px] text-gray-400 font-medium">
          {itemRequests.length} PENDING
        </div>
      </div> */}

      {loading ? (
        <div className="flex justify-center items-center h-32">
          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-cyan-600"></div>
        </div>
      ) : (
        <div className="overflow-x-auto border rounded-lg">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-3 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">
                  Code
                </th>
                <th className="px-3 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">
                  Description
                </th>
                <th className="px-3 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">
                  Req. User
                </th>
                <th className="px-3 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">
                  Date
                </th>
                <th className="px-3 py-3 text-center text-xs font-bold text-gray-500 uppercase tracking-wider">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-100">
              {itemRequests.map((item, index) => (
                <tr
                  key={item.soUid || index}
                  className="hover:bg-blue-50/50 transition-colors"
                >
                  <td className="px-3 py-3 text-xs font-semibold text-red-600 whitespace-nowrap">
                    {item.code}
                  </td>
                  <td className="px-3 py-3 text-xs text-gray-600 min-w-[100px]">
                    <div
                      className="whitespace-normal break-words break-all"
                      title={item.description}
                    >
                      {item.description}
                    </div>
                  </td>
                  <td className="px-3 py-3 text-xs text-gray-500 whitespace-nowrap">
                    <span className="bg-gray-100 px-2 py-0.5 rounded text-gray-700">
                      {item.Req_User}
                    </span>
                  </td>
                  <td className="px-3 py-3 text-xs text-gray-500 whitespace-nowrap">
                    {formatDate(item.req_date)}
                  </td>
                  <td className="px-3 py-3 text-center">
                    <button
                      onClick={() => handleCreateItem(item)}
                      className="bg-cyan-600 hover:bg-cyan-700 text-white px-4 py-1.5 rounded shadow-sm text-[10px] font-bold uppercase transition-all active:scale-95"
                    >
                      Create
                    </button>
                  </td>
                </tr>
              ))}
              {itemRequests.length === 0 && (
                <tr>
                  <td
                    colSpan="5"
                    className="px-3 py-10 text-center text-gray-400 text-xs italic"
                  >
                    No item requests found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ItemCreationTab;
